/**
 * Old platform URL by KTo3 host (hostname wins over build-time .env so one build
 * can serve both asymmetrical + cyurious production domains).
 */
const PLATFORM_MAP = {
  localhost: 'http://127.0.0.1:8000/Final_Library',
  '127.0.0.1': 'http://127.0.0.1:8000/Final_Library',
  'kto3.asymmetrical.ai': 'https://learning.asymmetrical.ai/Final_Library',
  'kto3.cyurious.com': 'https://learning.cyurious.com/Final_Library',
};

const DEFAULT_BY_BRAND = {
  cyurious: 'https://learning.cyurious.com/Final_Library',
  asymmetrical: 'https://learning.asymmetrical.ai/Final_Library',
};

function fallbackForHost(host) {
  const lower = host.toLowerCase();
  if (lower.includes('cyurious')) return DEFAULT_BY_BRAND.cyurious;
  if (lower.includes('asymmetrical')) return DEFAULT_BY_BRAND.asymmetrical;
  return DEFAULT_BY_BRAND.asymmetrical;
}

export function getOldPlatformUrl() {
  const host = window.location.hostname;

  if (PLATFORM_MAP[host]) {
    return PLATFORM_MAP[host];
  }

  const envUrl = process.env.REACT_APP_OLD_PLATFORM_DASHBOARD_URL;
  if (envUrl) {
    return envUrl;
  }

  return fallbackForHost(host);
}

export function redirectToOldPlatform() {
  window.location.href = getOldPlatformUrl();
}

/** Sign out only — must match the KTo3 site you are on (hostname wins, not .env). */
const SIGN_OUT_MAP = {
  localhost: 'http://127.0.0.1:8000/',
  '127.0.0.1': 'http://127.0.0.1:8000/',
  'kto3.cyurious.com': 'https://learning.cyurious.com/',
  'kto3.asymmetrical.ai': 'https://learning.asymmetrical.ai/',
};

export function getSignOutRedirectUrl() {
  const host = window.location.hostname;
  const lower = host.toLowerCase();

  if (SIGN_OUT_MAP[host]) {
    return SIGN_OUT_MAP[host];
  }

  if (lower === 'localhost' || lower === '127.0.0.1' || lower === '[::1]') {
    const base = (process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000').replace(/\/$/, '');
    return `${base}/`;
  }

  if (lower.includes('cyurious')) {
    return 'https://learning.cyurious.com/';
  }

  if (lower.includes('asymmetrical')) {
    return 'https://learning.asymmetrical.ai/';
  }

  return 'https://learning.asymmetrical.ai/';
}

export function redirectAfterSignOut() {
  window.location.replace(getSignOutRedirectUrl());
}
